import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["scoreOptions", "rangeOptions", "selectOptions", "booleanOptions", "valuesList", "valuesInput", "valueInput"]

  connect() {
    this.toggleOptions()
    if (this.hasValuesInputTarget) {
      this.initializeValues()
    }
  }

  initializeValues() {
    const valuesInput = this.valuesInputTarget
    if (!valuesInput.value) return

    try {
      // Versuche die Werte aus dem versteckten Input zu laden
      const values = JSON.parse(valuesInput.value)
      if (Array.isArray(values)) {
        // Lösche bestehende Werte
        this.valuesListTarget.innerHTML = ''
        // Füge jeden Wert als neues Input-Feld hinzu
        values.forEach(value => this.addValueWithContent(value))
      }
    } catch (e) {
      console.error('Fehler beim Parsen der Werte:', e)
    }
  }

  toggleOptions() {
    const fieldTypeSelect = this.element.querySelector('select[name="custom_property_definition[field_type]"]')
    if (!fieldTypeSelect) return

    const fieldType = fieldTypeSelect.value
    
    // Hide all option sections first
    this.hideAllOptions()
    
    // Show specific options based on field type
    if (fieldType === 'score') {
      this.showScoreOptions()
    } else if (fieldType === 'range') {
      this.showRangeOptions()
    } else if (fieldType === 'select') {
      this.showSelectOptions()
    } else if (fieldType === 'boolean') {
      this.showBooleanOptions()
    }
  }

  hideAllOptions() {
    if (this.hasScoreOptionsTarget) {
      this.scoreOptionsTarget.classList.add('hidden')
    }
    if (this.hasRangeOptionsTarget) {
      this.rangeOptionsTarget.classList.add('hidden')
    }
    if (this.hasSelectOptionsTarget) {
      this.selectOptionsTarget.classList.add('hidden')
    }
    if (this.hasBooleanOptionsTarget) {
      this.booleanOptionsTarget.classList.add('hidden')
    }
  }

  showScoreOptions() {
    if (this.hasScoreOptionsTarget) {
      this.scoreOptionsTarget.classList.remove('hidden')
    }
  }
  
  showRangeOptions() {
    if (this.hasRangeOptionsTarget) {
      this.rangeOptionsTarget.classList.remove('hidden')
    }
  }
  
  showSelectOptions() {
    if (this.hasSelectOptionsTarget) {
      this.selectOptionsTarget.classList.remove('hidden')
    }
  }
  
  showBooleanOptions() {
    if (this.hasBooleanOptionsTarget) {
      this.booleanOptionsTarget.classList.remove('hidden')
    }
  }

  addValue(event) {
    event.preventDefault()
    this.addValueWithContent('')
    this.updateValues()
  }

  addValueWithContent(value) {
    const valueItem = document.createElement('div')
    valueItem.className = 'select-value-item flex items-center gap-2 mb-2'
    valueItem.innerHTML = `
      <input type="text" name="select_values[]" 
        class="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md" 
        data-custom-property-target="valueInput"
        data-action="change->custom-property#updateValues"
        value="${value}">
      <button type="button" class="text-red-600 hover:text-red-800" data-action="click->custom-property#removeValue">
        <i class="fas fa-trash"></i>
      </button>
    `
    this.valuesListTarget.appendChild(valueItem)
  }

  removeValue(event) {
    event.preventDefault()
    const valueItem = event.target.closest('.select-value-item')
    if (valueItem) {
      valueItem.remove()
      this.updateValues()
    }
  }

  updateValues() {
    const values = this.valueInputTargets.map(input => input.value.trim()).filter(v => v.length > 0)
    this.valuesInputTarget.value = JSON.stringify(values)
  }
}